// import storage from 'store'
import { login, register, getUserInfo, logout } from '@/api/login'
import { message } from 'ant-design-vue'
const state = {
  token: '',
  user: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USER: (state, user ) => {
    state.user = user;
  }
}

  const actions = {
    // 登录
    Login ({ commit }, userInfo) {
      //登录注册前将token清空
      sessionStorage.removeItem('Authorization');
      // console.log("登录请求参数：" , userInfo.values);
      return new Promise((resolve, reject) => {
        login(userInfo.values).then((result) => {
          // console.log("返回参数：", result);
          commit('SET_TOKEN', result.token);
          sessionStorage.setItem('Authorization', result.token);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    //注册
    Register ({ commit }, userInfo) {
      commit;
      sessionStorage.removeItem('Authorization');
      return new Promise((resolve, reject) => {
        register(userInfo.values).then((result) => {
          result;
          // console.log("返回参数：", result);
          // commit('SET_TOKEN', result.token);
          // sessionStorage.setItem('Authorization', result.token);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
      
    },
    /**
     * 查询用户信息
     */
    getUserInfo({ commit }){
      getUserInfo().then( result => {
        // console.log("查询到的用户信息：", result);
        commit('SET_USER', result);
      }).catch( error => {
        message.error({
            content: '未查询到用户信息! ' + error.message,
            style: {
                marginTop: '20vh'
            },
            duration: 2
        });
      });
    },

    // 退出
    logout({ commit }) {
        //TODO 后端处理
        logout().then( () => {
          sessionStorage.clear();
          //清空状态管理中的登录数据
          commit('SET_TOKEN', null);
          commit('SET_USER', null);
        }).catch( error => {
          message.error({
            content: '退出登录失败! ' + error.message,
            style: {
                marginTop: '20vh'
            },
            duration: 2
          });
        });        
    }

  }

export default{
  namespaced: true,//用于全局引用此文件里的方法时标识这个文件名，解决命名冲突问题
  state,
  mutations,
  actions
}
